var exports = {
  "Xw": "RoleIcon.module__roleIconWrapper___OEo1bW",
  "ZT": "RoleIcon.module__roleIconImg___OEo1bW",
  "qr": "RoleIcon.module__roleIconEmoji___OEo1bW",
};

module.exports = exports;
